export default {
    getHeaderFields: state => state.headerFields,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getTableAdditionalConfig: state => state.tableAdditionalConfig,
}